import TreeLink from "@gtmhub/shared/tree-renderer/tree-link";

export class CurvedTreeLink extends TreeLink {
  protected static readonly htmlClass: string = "curved-tree-link";

  /**
   * renderIn
   * Appends a <svg> element with a nested <path> to the given drawingContainer, then moves the <svg>
   * to properly to join nodeA and nodeB, that are provided in the constructor.
   *
   * The result is a bezier-curve connecting the two nodes.
   *
   * @param {HTMLElement} drawingContainer
   * @return {void}
   */
  public renderIn(drawingContainer: HTMLElement) {
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
    const width = Math.abs(this.end.x - this.start.x);
    const height = Math.abs(this.end.y - this.start.y);
    const scale = Math.sign(this.end.y - this.start.y) < 0 ? "scale3d(1, -1, 1)" : "";

    svg.classList.add(CurvedTreeLink.htmlClass);
    svg.style.transform = `translate3d(${this.start.x}px, ${this.start.y}px, 0) ${scale}`;
    svg.style.width = `${width}px`;
    svg.style.height = `${height < 1 ? 1 : height}px`;

    path.setAttribute("d", `M 0,0 C ${width * 0.7},0 ${width * 0.3},${height} ${width},${height}`);

    svg.append(path);
    drawingContainer.append(svg);
  }
}
